import styled from 'styled-components';

export const StyledToast = styled.div`
  max-width: 35rem;
  width: 35rem;
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
`;

export const StyledContent = styled.div`
  display: inline;
`;

export const StyledBullets = styled.li`
  margin-left: 1rem;
`;
